import { ChecksumAddress } from "@silo/types";
import { isNull } from "@silo/utils";
import { createContext, useContext } from "react";

export const AssetAddressContext = createContext<ChecksumAddress>(null!);

export const useAssetAddressContext = () => {
  const context = useContext(AssetAddressContext);

  if (isNull(context)) {
    throw new Error(
      "Context is null. Only use useAssetAddressContext within a valid component."
    );
  }

  return context;
};
